import { type FeatureModule } from '@/components/routing';

/** Routes and nav entries of the `settings` feature. */
export const settingsFeature: FeatureModule = {
  id: 'settings',
  routes: [
    {
      path: 'settings',
      lazy: async () => ({ Component: (await import('./pages/settings-page')).SettingsPage }),
    },
  ],
  navItems: [{ to: '/settings', ns: 'settings', labelKey: 'nav.settings', icon: 'settings', order: 30 }],
};
